<template>
  <div class="login-canter">
    <div class="login-header">
      政务中枢
    </div>
    <div class="login-main">
      <div class="login-left">
        标准受理  ·  智慧管理  ·  业务赋能
        <img src="@/assets/images/login-bg.png" alt="">
      </div>
      <div class="login-right">
        <div class="login-form">
          <p>您好，欢迎登录！</p>
          <el-form label-position="top" label-width="80px" :model="loginInfo" :rules="rules" ref="loginInfo">
            <el-form-item label="用户名" prop="username">
              <el-input v-model="loginInfo.username" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              
            <div class="itemList">
              <span>密码</span>
              <el-input :type="passwordType" style="flex:1" placeholder="请输入登录密码" v-model="loginInfo.password" auto-complete="off" @keyup.native.enter="Submit('loginForm')">
                <i slot="suffix" class="iconfont unactive iconyanjing" v-show="!isVisible" @click="passVisible"></i>
                <i slot="suffix" class="iconfont iconyanjing1" v-show="isVisible" @click="passVisible"></i>
              </el-input>
            </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit('loginInfo')" :loading="loginLoading" style="width:100%">登 录</el-button>
            </el-form-item>
          </el-form>
          <div class="login-choice">
            <el-checkbox v-model="checked">记住用户名</el-checkbox>
            <el-link :underline="false" type="primary">忘记密码</el-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {login} from '@/api/login'
import { mapActions,mapMutations } from 'vuex'
const Base64 = require('js-base64').Base64
import { ACCESS_TOKEN, ACCESS_SECRET, ENCRYPTED_STRING } from '@/store/mutation-types'
import Vue from 'vue'
import { USER_INFO } from '@/store/mutation-types'
import { getFrontConfig } from 'ow-service-component'
export default {
  name: 'login',
  data () {
    return {
      loginInfo: {
        username: '',
        password: ''
      },
      isVisible: false,
      passwordType: 'password',
      checked: false,
      loginLoading:false,
      rules:{
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
      }
    }
  },
  created() {    
    let systemName = 'MAIN_CENTER_URL'
    const redirectUrl = getFrontConfig()['sso-config'][systemName]  // 系统地址
    if (getFrontConfig().SSO_URL && redirectUrl) {
      window.location.href = `${getFrontConfig().SSO_URL}login?redirect=${systemName}`
    }
    else {      
      Vue.ls.remove(ACCESS_TOKEN)
      Vue.ls.remove(ACCESS_SECRET)
    }
  },
  mounted () {
    let username = localStorage.getItem('username')
    if (username) {
      this.loginInfo.username = localStorage.getItem('username')
      this.loginInfo.password = Base64.decode(localStorage.getItem('password'))// base64解密
      this.checked = true
    }
  },
  computed: {

  },
  methods: {
    ...mapActions(['Login']),
    passVisible () {
      this.isVisible = !this.isVisible
      this.passwordType = this.isVisible ? 'text' : 'password'
    },
    onSubmit(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.checked) {
            let password = Base64.encode(this.loginInfo.password) // base64加密
            localStorage.setItem('username', this.loginInfo.username)
            localStorage.setItem('password', password)
          } else {
            localStorage.removeItem('username')
            localStorage.removeItem('password')
          }

          this.loginLoading = true
          let params = this.loginInfo
          this.Login(params).then(res => {
            if (res.success) {
              this.$store.dispatch('LoadHallInfo').then(res => {
                this.loginSuccess(res)
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.loginLoading = false
              })
            }
            else {
              this.$message('登录异常')
            }
          }).catch(err => {
            console.log(err)
          }).finally(()=>{
            this.loginLoading = false
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    
    loginSuccess() {
      // this.$router.push({ name: 'home' }).catch(err => console.log(err))
      this.$message.success('欢迎')
      let url = this.$route.query.redirect;
      if (url) {
        // 跳转回原页面
        this.$router.push({ 
          path: decodeURIComponent(url)
        });
      }else {
        let systemName = 'MAIN_CENTER_URL'
        const redirectUrl = getFrontConfig()['sso-config'][systemName]
        if (redirectUrl && getFrontConfig().SSO_URL) {
          window.history.pushState(null, '', `${__webpack_public_path__}subApplication/GovernmentGuideWeb`)
        } else {
          this.$router.push({ 
            path: '/subApplication/GovernmentGuideWeb'
          });
        }
      }
      
      
    },
  }
}
</script>

<style>
.login-form .el-form--label-top .el-form-item__label{
  padding: 0;
}
</style>
<style lang="less" scoped>
.login-canter{
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.login-header{
  padding: 35px 0;
  padding-left: 18.75%;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #111111;
}
.login-main{
  background: #4677EE;
  flex: 1;
  position: relative;
  .login-left{
    position: absolute;
    left: 20%;
    width: 32%;
    height: 100%;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    img{
      width: 100%;
    }
  }
  .login-right{
    position: absolute;
    padding: 40px 30px;
    background: #FFFFFF;
    border-radius: 6px;
    right: 18.75%;
    width: 25%;
    top: 50%;
    transform: translate(40%, -50%);
    p{
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }
  }
}
.login-choice{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.iconfont {
  font-size: 22px;
  color:#409eff;
  &.unactive{
    color:#c0c9db;
  }
}
</style>
